import React from "react";
import "../../../styles/artworks.css";
import CategoryCard from "../../cardHolders/categoriesCard";
import { inject, observer } from "mobx-react";
import ArtworkCard from "../../cardHolders/artworksCard";
import { Redirect ,withRouter} from "react-router-dom";
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateIfInputIsEmail,
    validateInputLength
} from "../../../helpers/validationChecks";
import CategorySection from '../../sectionHolders/categorySectionHolder'
import ArtistOfTheMonthSection from '../../sectionHolders/artistOfTheMonthSection'
import CommissionRequestSection from '../../sectionHolders/comissionRequestSection'
import ArtistsAndArtworksSection from '../../sectionHolders/artistsAndArtworksCardSection'
var qs = require('qs')
@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'categoryPageArtworksStore')
@withRouter
@observer
export default class artworks extends React.Component {
    constructor() {
        super();
        this.state = {
            featuredArtworksList: []
        }
    }
    handleViewAll(item) {
        switch (item) {
            // case ("following"): {
            // sample    this.props.categoryPageArtworksStore.setQuery({ following: "True", }, "FROM ARTISTS YOU FOLLOW")
            //     this.setState({
            //         viewAll: true,
            //         query: qs.stringify({ following: "True" })
            //     })
            //     break;
            // }
            case ("Featured"): {
                this.props.categoryPageArtworksStore.setQuery({ search: "Featured" }, "FEATURED ARTWORKS")
                this.setState({
                    viewAll: true,
                    query: qs.stringify({ search: "Featured" }),
                    keyword: "Featured",
                    title: "FEATURED ARTWORKS"
                })
                break;
            }
            case ("living_room"): {
                this.props.categoryPageArtworksStore.setQuery({ search: "living_room" }, "FOR THE LIVING ROOM")
                this.setState({
                    viewAll: true,
                    query: qs.stringify({ search: "living_room" }),
                    keyword: "living_room",
                    title: "FOR THE LIVING ROOM"
                })
                break;
            }
            case ("bedroom"): {
                this.props.categoryPageArtworksStore.setQuery({ search: "bedroom" }, "FOR THE BEDROOM")
                this.setState({
                    viewAll: true,
                    query: qs.stringify({ search: "bedroom" }),
                    keyword: "bedroom",
                    title: "FOR THE BEDROOM"
                })
                break;
            }
            case (""): {
                this.props.categoryPageArtworksStore.setQuery({ search: "" }, "JUST IN")
                this.setState({
                    viewAll: true,
                    query: qs.stringify({ search: "" }),
                    keyword: "just-in",
                    title: "JUST IN"
                })
                break;
            }

        }

    }
    componentDidMount() {
        if (localStorage.hasOwnProperty("userData")) {
            this.props.userStore.pulluser().then((result) => {
                // console.log("{this is pulled user}", result)
                result.data[0]
                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    formData.append("display_name", this.state.formInputs.display_name)
                    // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                    this.props.userStore.validateDisplayName(formData)
                        .then((response) => {
                            // console.log(response)
                            if (response.error == "True") {
                                this.setState({
                                    onboardingThreeIncomplete: true,
                                    // formInputs: { ...this.state.formInputs, display_name: "" }
                                })
                                // this.props.navigatorStore.openErrorModal(response.data)
                                return;
                            }
                            else {
                                this.setState({
                                    onboardingThreeIncomplete: true
                                })
                            }
                        })
                        .catch((err => {
                            this.setState({
                                onboardingThreeIncomplete: true,



                            })
                        }));
                }

                if (result.data[0].display_name) {
                    if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                }
                // if (!result.data[0].interests) {
                //     // console.log("interests null")
                //     this.setState({
                //         onboardingOneIncomplete : true
                //     })
                // }
                // if (!result.data[0].preferences) {
                //     // console.log("preferences null")
                //     this.setState({
                //         onboardingTwoIncomplete : true
                //     })
                // }
                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    // console.log("profile null")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    // this.state.makeOnboardingThreeIncomplete()
                }

            })
        }
        this.props.navigatorStore.artworksPageActive(true);
        if (localStorage.hasOwnProperty("userData")) {
            this.props.landingPageArtworksStore.getInitialArtworksByCategory({ search: "Featured" })
                .then((res) => {
                    // console.log("[look at response]", res)
                    if (res) {
                        this.setState({

                            featuredArtworksList: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })
            this.props.landingPageArtworksStore.getInitialArtworksByCategory({ search: "living_room" })
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            livingRoomArtworksList: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })
            this.props.landingPageArtworksStore.getBrowseAllCategoryArtworks({})
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            recentArtworksList: (res.data) ? res.data.data : {}
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })
            this.props.landingPageArtworksStore.getInitialArtworksByCategory({ search: "bedroom" })
                .then((res) => {
                    if (res) {
                        // console.log("[look at response]", res)
                        this.setState({

                            bedroomArtworksList: res.data.data
                        }, function () {
                            // console.log("[look at artworks state]", this.state.artworksList);
                            // console.log(this.state.response)
                        })
                    }
                })
                this.props.landingPageArtworksStore.getInitialArtworksByCategoryPublic({ search: "YMC Unconventional" })
                .then((res) => {

                    // console.log("[look at response]", res)
                    this.setState({

                        unconventional_artworks: (res.data) ? res.data.data : []
                    }, function () {
                        // console.log("[look at artworks state]", this.state.artworksList);
                        // console.log(this.state.response)
                    })
                })
        }else {
            // this.props.history.replace('/')
        this.props.navigatorStore.openSignInModal();
     
                 }
    }
    componentWillUnmount() {
        if (localStorage.hasOwnProperty("userData")) {
        this.props.navigatorStore.artworksPageActive(false);
        }
    }
    render() {
        var bg = require('../../../assets/watercolor_category.png')
        const artworksForSpaces = [
            { value: "YMC Living", name: 'LIVING ROOM', path: require('../../../assets/livingroom_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._SY500_.jpg" },
            { value: "YMC Bedroom", name: 'BEDROOM', path: require('../../../assets/bedroom_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._SY500_.jpg" },
            { value: "YMC Cafes", name: 'CAFES', path: require('../../../assets/cafe_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._SY500_.jpg" },
            { value: "YMC Workspaces", name: 'WORKSPACES', path: require('../../../assets/office_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._S" }
        ]
        const trendingStyles = [
            { value: "T2019 Global Aesthetics", name: 'Global Aesthetics', path: require('../../../assets/artistic.jpg'), colored: true },
            { value: "T2019 Modern Botanical", name: 'Modern Botanical', path: require('../../../assets/botanicals.jpg'), colored: true },
            { value: "T2019 Black & White", name: 'Black & White', path: require('../../../assets/blacknwhite.jpg'), colored: true },
            { value: "T2019 Maximalism", name: 'Maximalism', path: require('../../../assets/maximalism.jpg'), colored: true }
        ]

        const ym_collection= [
            // { type: "search", value: "Pencil", name: 'PENCIL', path: require('../../../assets/pencil.jpg'), colored: true },
            { value: "YMC Portraits", name: 'PORTRAITS', path: require('../../../assets/portraits_thumb.jpg'), colored: true },
            { type: "search", value: "Oil", name: 'OIL', path: require('../../../assets/oil.jpg'), colored: true },
            { value: "YMC Abstract", name: 'ABSTRACT', path: require('../../../assets/abstract_thumb.jpg'), colored: true },
            { value: "YMC Landscape", name: 'LANDSCAPE', path: require('../../../assets/landscape_thumb.jpg'), colored: true },
        ]

        if (this.props.authStore.RegisterSuccess) {
            this.props.authStore.resetRegisterSuccess("onboardingOneIncomplete")
            this.props.authStore.resetRegisterSuccess("onboardingTwoIncomplete")
            this.props.authStore.resetRegisterSuccess("onboardingThreeIncomplete")
            return (
                <Redirect push to='/onboardingone' />
            )
        }

        if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingOneIncomplete) {
            // console.log("redirecting to onboardingOne");
            return (
                <Redirect push to="/onboardingone"></Redirect>
            )
        }
        if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingTwoIncomplete) {
            // console.log("redirecting to onboardingTwo");
            return (
                <Redirect push to="/onboardingtwo"></Redirect>
            )
        }
        if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingThreeIncomplete) {
            // console.log("redirecting to onboardingThree");
            return (
                <Redirect push to="/onboardingthree"></Redirect>
            )
        }

        if (this.state.viewAll) {
            return (
                <Redirect push to={{ pathname: `/categorypoducts/${this.state.query}/${this.state.title}` }} />
            )
        }



        return (
            <div className="main-container-artworks-page">
                <div className="title-section-artworks-page" >
                    <div className="title-artist-page">
                        ARTWORKS
                        <hr className="primary-golden-rule"></hr>
                        <br />
                    </div>
                </div>

                <ArtistsAndArtworksSection 
                title="BROWSE ALL ARTWORKS" colored={false} artistSection={false} 
                artworkData={this.state.recentArtworksList} keyword="" />
                <ArtistsAndArtworksSection 
                title="FEATURED ARTWORKS" colored={true} 
                artistSection={false} artworkData={this.state.featuredArtworksList}
                 keyword="Featured" short_desc="Discover our carefully curated collection of original pieces of art -  the only one of its kind to exist!
                 " />
                <CategorySection title={"ARTWORKS FOR SPACES"}
                 categoryData={artworksForSpaces} viewAll={true}
                  colored={false} short_desc=" Looking to decorate your space? We bring you art that not only decorates but defines your space. Select art that is personal to you and surround yourself with things you love!                  " viewAll={true} keyWord="spaces" />
                <CategorySection title={"TRENDING STYLES"} categoryData={trendingStyles} viewAll={false} colored={true} short_desc="We have curated the best artworks mirroring the latest trends in the art world for you. Check out what’s trending around the world now!" viewAll={true} keyWord="styles" />
                <ArtistsAndArtworksSection title="UNCONVENTIONAL ARTWORKS" colored={false} artistSection={false} artworkData={this.state.unconventional_artworks} keyword="YMC Unconventional"
                short_desc="If individualistic art is your type, discover thought provoking artworks that speak louder than a thousand words with this collection. 
                "
                />
                <CategorySection
                 title={"BROWSE ARTWORKS BY OUR COLLECTIONS"} 
                 categoryData={ym_collection} viewAll={true}
                  colored={true} short_desc="
                  Discover irreplaceable original artworks picked by our curators only for you to give your interiors an aesthetic appeal that speaks of your style!

" viewAll={true} keyWord="ym_collection" />



            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/Home/profile/artworks.js